





























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import { UnitSystem } from '@/interfaces/units';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import { getLayerPresets } from '@/modules/design/lib/calculations/aashtoRecommendations';
import {
  IAcOverlayDesignImperial,
  IAcOverlayDesignMetric,
  IAcOverlayLayerImperial,
  IAcOverlayLayerMetric,
} from '@/modules/design/interfaces/acOverlay';
import { CM_TO_INCHES } from '@/lib/unitConversion/unitConversionFactors';
import CoreQuestions from '@/modules/design/views/acOverlay/components/CoreQuestions.vue';

@Component({
  components: {
    CoreQuestions,
    PxDropdown,
    PxNumberInput,
    QuickHelp,
  },
})
export default class AcOverlayConditionSurvey extends Vue {
  @Prop() readonly page!: number;

  @Prop({ default: true }) readonly showDefaultCardBody!: boolean;

  @Prop() scenario!: IAcOverlayDesignImperial | IAcOverlayDesignMetric;

  @Prop() scenarioImperial!: IAcOverlayDesignImperial;

  @Prop({ default: null }) validationObject!: any;

  validations() {
    return this.validationObject;
  }

  layerFields = [
    'type',
    'thickness',
    { key: 'aashto', label: 'AASHTO Recommendation' },
    { key: 'layerCoefficient', label: 'Layer Coefficient (a)' },
    { key: 'drainageCoefficient', label: 'Drainage Coefficient (m)' },
    { key: 'sn', label: 'SN' },
  ];

  unitSystemImperial = UnitSystem.Imperial;


  yesNoOptions = [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' },
  ];

  alligatorCrackingOptions = [
    { value: '0', text: '0%' },
    { value: '<10', text: '<10%' },
    { value: '>10', text: '>10%' },
  ];

  transverseCrackingOptions = [
    { value: '0', text: '0%' },
    { value: '<5', text: '<5%' },
    { value: '5-10', text: '5% - 10%' },
    { value: '>10', text: '>10%' },
  ];

  get depthUnit() {
    if (this.scenario.displayUnits === UnitSystem.Imperial) {
      return 'in';
    }
    return 'cm';
  }

  get thicknessUnit() {
    return this.depthUnit;
  }

  layerPresets(layer: IAcOverlayLayerImperial | IAcOverlayLayerMetric) {
    return getLayerPresets(layer.type, this.fatigue_cracking, this.transverse_cracking);
  }

  get fatigue_cracking() {
    return {
      low: this.scenario.alligatorLow || '',
      medium: this.scenario.alligatorMed || '',
      high: this.scenario.alligatorHigh || '',
    };
  }

  get transverse_cracking() {
    return {
      low: this.scenario.transverseLow || '',
      medium: this.scenario.transverseMed || '',
      high: this.scenario.transverseHigh || '',
    };
  }

  get snWarning(): string | null {
    const warningText = 'Open Graded Asphalt layers must be milled prior to placing a structural overlay therefore this layer will be removed from the design consideration.';
    // @ts-ignore
    const showWarning: boolean = this.scenario.existingLayers.filter((L) => L.type === 'Asphalt - Open Graded').length > 0;
    console.log('running snWarning', showWarning);
    return showWarning ? warningText : null;
  }

  get totalSn(): number {
    let totalSn = 0;

    this.scenario.existingLayers.forEach((L: IAcOverlayLayerImperial | IAcOverlayLayerMetric) => {
      if (L.type === 'Asphalt - Open Graded') {
        L.sn = 0;
      } else {
        // @ts-ignore
        const t = this.scenario.unitSystem === UnitSystem.Imperial ? L.thickness_in : L.thickness_cm * CM_TO_INCHES;
        L.sn = (L.layerCoefficient || 0) * L.drainageCoefficient * t;
        totalSn += L.sn;
      }
    });

    return totalSn;
  }

  get layerCoefficientWarnings(): string[] {
    const warnings: string[] = [];

    if (this.scenarioImperial.millRemoveDistressed && this.scenarioImperial.removeDepth_in !== null && this.scenarioImperial.removeDepth_in > 0) {
      warnings.push(`You have elected to remove ${this.scenarioImperial.removeDepth_in} ${this.thicknessUnit}. of pavement from the surface. This may impact the layer coefficient you select.`);
    }
    if (
      this.scenarioImperial.millRemoveDistressed
      && this.scenarioImperial.crackDepth_in !== null
      && this.scenarioImperial.distressDepth_in !== null
      && this.scenarioImperial.removeDepth_in !== null
      && (this.scenarioImperial.removeDepth_in < this.scenarioImperial.crackDepth_in || this.scenarioImperial.removeDepth_in < this.scenarioImperial.distressDepth_in)
    ) {
      warnings.push('You have either top-down cracking or delamination that will not be removed prior to placing an overlay. Consider removing to the depth of the deterioration indicated in the previous step.');
    }
    return warnings;
  }

  sync() {
    this.$emit('sync');
  }
}
